var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.debug)?_c('div',{staticStyle:{"background":"white","padding":"7px","margin-bottom":"40px"}},[_c('h3',[_vm._v("Debug")]),_vm._v(" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }